import { userProfileConstants } from '../../_constants';
import { userProfileService } from '../../_services';

export const changePasswordAction = {
    changePasswordHandler
};

function changePasswordHandler(data) {
    return dispatch => {
        dispatch(request());
        userProfileService.changePasswordHandler(data)
            .then(
                changePassword => {
                    dispatch(success(changePassword));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: userProfileConstants.REQUEST_CHANGE_PASSWORD} }
    function success(changePassword) { return { type: userProfileConstants.RECEIVE_CHANGE_PASSWORD, changePassword } }
    function failure(error) { return { type: userProfileConstants.CHANGE_PASSWORD_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/UserProfile/changePassword.action.js